module.exports = __webpack_public_path__ + "img/logo.23f977f2.png";